import { useId, useState } from "react"
import { PREVIEW_FRESHNESS, type RunFeedPreviewFreshness } from "@nova-ai/shared"

import { Button } from "../ui/button"
import { RunPreviewFreshnessNotice } from "./run-preview-freshness-notice"
import { ProductValueRecoveryPanel } from "./product-value-recovery-panel"

export function RunValueRecovery({
  marketplace,
  originatingRunId,
  slug,
  runProductCount,
  freshness,
  needsValidation,
  error,
}: {
  marketplace: string
  originatingRunId: number
  slug: string
  runProductCount: number
  freshness: RunFeedPreviewFreshness | undefined
  needsValidation: boolean
  error: Error | null
}) {
  const [isOpen, setIsOpen] = useState(false)
  const panelId = useId()
  const isHistorical = freshness?.kind === PREVIEW_FRESHNESS.historical
  return (
    <div className="shrink-0 space-y-3">
      <RunPreviewFreshnessNotice
        freshness={freshness}
        needsValidation={needsValidation}
        error={error}
      >
        <Button
          size="sm"
          className="mt-3"
          aria-expanded={isOpen}
          aria-controls={panelId}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? "Hide value recovery" : "Review value recovery"}
        </Button>
      </RunPreviewFreshnessNotice>

      {isOpen && (
        <section
          id={panelId}
          aria-label="Value recovery"
          className="max-h-[65vh] overflow-y-auto rounded-xl border border-border bg-card p-4 text-sm"
        >
          <ProductValueRecoveryPanel
            marketplace={marketplace}
            originatingRunId={originatingRunId}
            slug={slug}
            runProductCount={runProductCount}
            freshness={freshness}
          />

          {!isHistorical && (
            <Button size="sm" className="mt-3" onClick={() => setIsOpen(false)}>
              Close value recovery
            </Button>
          )}
        </section>
      )}
    </div>
  )
}
